// eslint-disable-next-line import/prefer-default-export
export function downloadBlobAsFile(fileName, data) {
    const url = window.URL.createObjectURL(data.data);
    const link = document.createElement('a');
    link.href = url;
    if (fileName) {
        link.download = fileName;
    }
    else {
        link.download = data.headers['content-disposition'].match(/filename=(.+)/)[1].trim();
    }
    link.click();
}